import { render, staticRenderFns } from "./teacherCourse.vue?vue&type=template&id=0a8b03d2"
import script from "./teacherCourse.vue?vue&type=script&lang=js"
export * from "./teacherCourse.vue?vue&type=script&lang=js"
import style0 from "./teacherCourse.vue?vue&type=style&index=0&id=0a8b03d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports